import Loginpage from "../components/Loginpage";

const Login = () => {
  return (
    <div className="">
      <Loginpage />
    </div>
  );
};

export default Login;
